import { render, staticRenderFns } from "./IChing.vue?vue&type=template&id=945918de&"
import script from "./IChing.vue?vue&type=script&lang=js&"
export * from "./IChing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports